//source: https://gist.github.com/asidko/9c7064027039411a11323eaf7d8ea2a4

import {makeLogger} from '../../../../logger/logger';

const {
  info,
  // debug,
  warn,
  err
} = makeLogger({
  pathToCurrentFile: 'components/strategies/services/precaching-service/compression.ts',
});

const blobToBase64 = async (blob: Blob): Promise<string> => {
    if (typeof FileReader == 'function') { //in the browser there is FileReader to work with streams, but there is no Buffer
      return await new Promise((resolve, reject) => {
          try{
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve((reader.result! as string).split(',')[1] as string);
            };
            reader.onerror = (e) => {
                err('Error reading blob', e);
                reject(e);
            };
            reader.readAsDataURL(blob);
          }catch(e){
            err('Error converting blob to base64', e);
            reject(e);
          }
      });
    } else { //in nodejs there are no FileReader, so we need to use Buffer
      const arrayBuffer = await blob.arrayBuffer();
      return Buffer.from(arrayBuffer).toString('base64') as string;
    }
};

const base64ToBlob = async (base64: string): Promise<Blob> => {
    const binary = atob(base64);
    const array = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      array[i] = binary.charCodeAt(i);
    }
    return new Blob([array]);
};

/**
 * Compresses input string with GZIP algorithm and returns base64 encoded string.
 * @param input
 * @returns {Promise<string>} base64 encoded compressed string
 */
export const compress = async (input: string, mode: 'gzip'|'deflate'|'deflate-raw' = 'gzip'): Promise<string> => {

    const cs = new CompressionStream(mode);
    const stream = new Blob([input]).stream();
    const compressed = stream.pipeThrough(cs);
    const reader = compressed.getReader();
    const chunks = [];

    while(true){ // eslint-disable-line no-constant-condition
      const chunk = await reader.read();
      if(chunk.done){
        break;
      }
      chunks.push(chunk.value);
    }
    const blob = new Blob(chunks);
    const based = await blobToBase64(blob);
    info('Compressed data length', input.length, '=>', based.length);
    return based;
};

export const decompress = async(base64string: string): Promise<string> => {
    const ds = new DecompressionStream('gzip');
    const blob = await base64ToBlob(base64string);
    const stream = blob.stream();
    stream.pipeThrough(ds);
    const reader = ds.readable.getReader();
    const chunks = [];
    while(true){ // eslint-disable-line no-constant-condition
      const chunk = await reader.read();
      if(chunk.done){
        break;
      }
      chunks.push(chunk.value);
    }
    return await new Blob(chunks).text();
};

// Decompresses base64 encoded GZIP string. Returns a string with original text.
export const decompress2 = async (base64string: string): Promise<string> => {
    return new Promise(async (resolve, reject) => { //eslint-disable-line no-async-promise-executor
        try{
          const bytes = Uint8Array.from(atob(base64string), c => c.charCodeAt(0));
          const cs = new DecompressionStream('gzip');
          const writer = cs.writable.getWriter();
          //console.log('decompression stream will write');
          await writer.write(bytes);
          await writer.close();
          //console.log('written');
          new Response(cs.readable).arrayBuffer().then(function (arrayBuffer) {
              const r = new TextDecoder().decode(arrayBuffer) as string;
              resolve(r);
          }).catch(e=>{
              reject(e);
          });
        }catch(e){
          reject(e);
        }
    });
};
